import * as React from 'react'

import { classList } from 'react-classlist-helper'

interface IProps {
  text: string
  withLeftMargin?: boolean
}

export default class UploadButton extends React.PureComponent<IProps> {
  public render() {
    const { text, withLeftMargin = true } = this.props

    return (
      <div className="tw:flex tw:items-center">
        <div className="tw:flex tw:items-center tw:grow-0">
          <span
            className="upload-button-icon tw:w-5 tw:h-5 tw:rotate-180 tw:bg-no-repeat"
            style={{ backgroundImage: 'url(/static/icons/download.svg)' }}
          />
        </div>
        <span
          className={classList({
            'tw:w-max tw:text-body-md tw:text-foreground': true,
            'tw:ml-[5px]': withLeftMargin,
          })}
        >
          {text}
        </span>
      </div>
    )
  }
}
